import { Center, Loader } from '@qred/components-library';
import { usePostHog } from 'posthog-js/react';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '~/store';

/**
 * To be used for onboarding routes that should be using the new onboarding subdomain.
 */
export const RedirectToOnboardingDomain = () => {
  const posthog = usePostHog();
  const { language } = useSelector((state: RootState) => state.intl);

  useEffect(() => {
    const isLocalHost = window.location.hostname === 'localhost';
    if (isLocalHost) {
      throw new Error(
        'The redirect to onboarding domain does not work on localhost. Please test this in the test environment.'
      );
    }

    const newUrl = new URL(window.location.href);
    // Replace everything up until the first dash or dot in the hostname with 'onboarding'
    newUrl.hostname = newUrl.hostname.replace(/^[^-.]+/, 'onboarding');

    const referrer = sessionStorage.getItem('referrerUrl') || document.referrer;

    if (referrer) {
      newUrl.searchParams.set('originalReferrer', encodeURI(referrer));
    }

    newUrl.searchParams.set('redirectedFromMyQred', 'true');
    newUrl.searchParams.set('language', language);

    posthog.capture(
      'onboarding_redirect_user_from_my_qred_onboarding_route_to_onboarding_subdomain',
      {
        from: window.location.href,
        to: newUrl.href,
      }
    );

    window.location.replace(newUrl);
  }, [language, posthog]);

  return (
    <Center h="100vh">
      <Loader size={'xxl'} />
    </Center>
  );
};
